export default "__VITE_ASSET__k0oYrWzm__"